export const compareArray = (a, b) => {
  const newA = a.sort();
  const newB = b.sort();
  return newA.length === newB.length && newA.every((v, i) => v === newB[i]);
};
